import { render, staticRenderFns } from "./Ring.vue?vue&type=template&id=7c377a2b&"
var script = {}
import style0 from "./Ring.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports